<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";
import { generateToken } from 'src/modules/recaptcha_v3_module.js'

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      form: {
        success: false,
        errors: [],
        loading: false,
        data: {}
      }
    }
  },
  methods: {
    getFormField(fieldName) {
      return this.formFields.filter(field => field.name == fieldName)[0] || {};
    },
    getFormData () {
      const formData = new FormData();
      this.formFields.forEach(field => {
        if (field.type == "hidden") {
          formData.append(this.getFieldInputName(field.name), field.value);
        } else {
          const formDataValue = this.form.data[field.name];
          if (formDataValue) {
            formData.append(this.getFieldInputName(field.name), formDataValue);
          }
        }
      });

      formData.append("interaction_id", this.content.newsletter.interaction.id);
      formData.append("content_id", this.containerContent.id);

      return formData;
    },
    getFieldInputName(fieldName) {
      return `user_upload_interaction[${fieldName}]`;
    },
    tracking() {
      sendFandomAnalyticsEvent('Newsletter', 'Newsletter Registration', globalState.pageModel.main_content_name);
      if (typeof fbq != "undefined") {
        fbq('track', 'Subscribe');
      }
    },
    submitSimpleForm(event) {
      if (!this.form.loading) {
        this.form.success = false;
        this.form.loading = true;
        this.form.errors = null;

        let submitForm = (token) => { 
          const data = this.getFormData();
          if (token)
            data.append("recaptcha_enterprise_token", token);

          Fandom.ajax({
              processData: false,
              contentType: false,
              method: "POST",
              url: "/upload_simple_form",
              data: data,
              success: (data) => {
                this.form.success = data.success;
                if (this.form.success) {
                  this.form.data = {};
                } else {
                  this.form.errors = data.errors;
                }
                this.tracking();
              }
            },
            () => {
              this.form.loading = false;
            }
          );
        };

        if (globalState.pageModel.aux.recaptcha_enterprise) {
          generateToken(submitForm, "submit");
        } else {
          submitForm();
        }
      }
    },
  },
  computed: {
    formFields() {
      return JSON.parse(this.content.newsletter.form_fields).fields;
    }
  }
};

</script>

<template>
  <div class="bg-cheddar py-3 px-md-4" stripe-newsletter>
    <form class="w-100" @submit.prevent="submitSimpleForm($event)">
      <div class="container px-0">
        <div class="row m-0 py-3 py-md-4 justify-content-md-between">
          <div class="col-12 col-md-6 col-lg-4">
            <h4>{{content.newsletter.title}}</h4>
            <div class="form-group form-check mt-3 d-none d-md-block my-0" v-if="getFormField('newsletter') && getFormField('newsletter').type != 'hidden'">
              <input type="checkbox" class="form-check-input" v-model="form.data.newsletter">
              <label class="form-check-label font-sm" v-html="content.newsletter.description"></label>
            </div>
          </div>  
          <div class="col-12 col-md-6 pt-3 pb-4 align-self-end">     
            <form-feedback :errors="form.errors" :success="form.success" :success-message="content.newsletter.feedback" class="mb-3 w-100"></form-feedback>
            <div class="d-flex w-100">
              <input type="text" class="custom-input w-100" v-model="form.data.email" :placeholder="getFormField('email').placeholder">
              <button type="submit" class="btn btn-cinnamon px-4 py-2">{{content.newsletter.button_title}}</button>
            </div>
          </div>
          <div class="col-12 d-md-none" v-if="getFormField('newsletter') && getFormField('newsletter').type != 'hidden'">
            <div class="form-group form-check">
              <input type="checkbox" class="form-check-input" v-model="form.data.newsletter">
              <label class="form-check-label font-sm" v-html="content.newsletter.description"></label>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<style lang="scss">
[stripe-newsletter] {
  $button-width: 7.5rem;
  min-height: 22.875rem;

  .form-check-input {
    margin-top: 0 !important;
  } 

  .custom-input {
    height: 4rem;
    border: 0px;
    padding-left: 1.5rem;

    &:active, &:focus {
      outline: none;
    }
  }

  .btn {
    min-width: $button-width;
  }
}
</style>